<template>
  <div class="wrapper">
    <div class="bg-dark-03">
      <div class="container text-center">
        <div class="middle">
          <div class="row">
            <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
              <div class="bg-white box-shadow-with-hover padding-50 padding-lg-70">
                <h1 class="display-1 font-weight-bold">404</h1>
                <p class="font-large">Sorry, It appears that the page you were looking for doesn't exist or might have been moved.</p>
                <div class="margin-top-40">
                  <router-link to="/" class="button button-xl button-rounded button-dark">Go home</router-link>
                </div>
              </div>
            </div>
          </div><!-- end row -->
        </div><!-- end middle -->
      </div><!-- end container -->
    </div><!-- end bg-dark-* -->
</div><!-- end wrapper -->
</template>
<script>
  export default {
    name: 'NotFoundView'
  }
</script>
